import { Component, Input } from '@angular/core';
import { CardBadgeKind, IRecordCard } from '../../driver-background-check.view-models';

@Component({
  selector: 'app-bgc-section-watchlist',
  templateUrl: './bgc-section-watchlist.component.html',
  styleUrls: ['./bgc-section-watchlist.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionWatchlistComponent {
  @Input() cards: IRecordCard[] = [];

  trackByCard(index: number, card: IRecordCard): string {
    return card.id;
  }

  badgeClass(kind: CardBadgeKind): string {
    return `badge-kind-${kind}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-watchlist/bgc-section-watchlist.component.ts